/* tslint:disable */
/* eslint-disable */
/**
 * Careplatform Authentication API
 * An API to use to authenticate users
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: bjorn.naeslund@r2m.se
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * User authority
 * @export
 * @enum {string}
 */
export enum UserAuthorityType {
    AttendMeeting = 'ATTEND_MEETING',
    BookMeeting = 'BOOK_MEETING',
    BookMeetingOther = 'BOOK_MEETING_OTHER',
    CreateUserStaff = 'CREATE_USER_STAFF',
    SendMessage = 'SEND_MESSAGE',
    CreateUserClient = 'CREATE_USER_CLIENT',
    AdminSite = 'ADMIN_SITE',
    AppointAdminSite = 'APPOINT_ADMIN_SITE',
    CreateUserPlatformAdmin = 'CREATE_USER_PLATFORM_ADMIN',
    CustomerSettings = 'CUSTOMER_SETTINGS',
    ChangeCustomerStatus = 'CHANGE_CUSTOMER_STATUS'
}

export function UserAuthorityTypeFromJSON(json: any): UserAuthorityType {
    return UserAuthorityTypeFromJSONTyped(json, false);
}

export function UserAuthorityTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserAuthorityType {
    return json as UserAuthorityType;
}

export function UserAuthorityTypeToJSON(value?: UserAuthorityType | null): any {
    return value as any;
}

